import { FC, ReactNode } from 'react';

import styles from './SmallButton.scss';

//This component is used for A/B test, if test is successful, we need to move it to dibs-elements/exports/Button component
export const SmallButton: FC<{ children: ReactNode; onClick: () => void }> = ({
    children,
    onClick,
}) => {
    return (
        // eslint-disable-next-line react/forbid-elements
        <button type="button" className={styles.button} onClick={onClick}>
            {children}
        </button>
    );
};
